import moment from 'moment';
import { useRef } from 'react';

export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

export interface TabProps {
  toScroll?: number;
  resetScroll?: () => void;
}

export enum AnniProjectActionType {
  write = `write`,
  complete = `complete`,
  admin = `admin`,
  detail = `detail`,
}
export interface AnniProjectProps extends ModalProps {
  queryParams: any;
  action: AnniProjectActionType;
  id: number;
  // 팝업 화면 전환
  goto: (action: AnniProjectActionType, idx: number) => void;
}

export interface AnniProjectDetailProps extends AnniProjectProps {
  // 제목 반환
  setPopupTitle: (title: string) => void;
}

export interface AnniProjectDataType {
  aprjtName?: string; // 프로젝트명
  aprjtMessage?: string; // 메시지
  anniType?: string; // 기념일 종류
  anniDate?: string; // 기념일
  supportIndexNumber?: number; // 지원사업
  goalAmount?: number; // 목표금액
  goalStartDate?: string; // 목표기간 시작일
  goalEndDate?: string; // 목표기간 종료일
  confirmPublicYn?: string; // 공개동의
  confirmPushYn?: string; // 메일수신 동의
}

export interface AnniProjectSupportDataType {
  aprjtIdx?: number; // 프로젝트 일련번호
  story?: string; // 축하메시지
  openNameYn?: string; // 이름 공개 여부
  openAmountYn?: string; // 금액 공개 여부
  supportTerm?: string; // 후원방법 (정기/일시)
  supportCategory?: string; // 후원분야
  atype?: string; // 기념일 타입 (anniType 에서 AT를 제거한 값)
  anniDate?: string; // 기념일
}

export const AnniProjectMessage = {
  DefaultTitle: '같이 하는 기념기부',
  PageLoading: 'Loading...',
  PageNotFound: '찾을 수 없는 페이지입니다.',
  GiftBlockMsg: '운영자가 삭제한 메시지입니다.',
};

export const AnniProjectFormTerms = [
  {
    value: `Y`,
    text: `동의함`,
  },
  {
    value: `N`,
    text: `동의하지 않음`,
  },
];

export const getAnniEndDDay = (endDate: string): number => {
  let dday = 0;
  // eslint-disable-next-line no-restricted-globals
  if (endDate !== '' && !isNaN(Date.parse(endDate))) {
    const diff = moment(endDate).diff(new Date());
    if (diff > 0) {
      dday = Math.ceil(diff / (1000 * 3600 * 24));
    }
  }
  return dday;
};

export const getAnniStateCss = (state: string): string => {
  let cssName = '';
  switch (state) {
    case '0': // 대기
      cssName = 'wait';
      break;
    case '1': // 수정
      cssName = 'edit';
      break;
    case '2': // 보류
      cssName = 'defer';
      break;
    case '3': // 진행
      cssName = 'ing';
      break;
    case '4': // 종료
      cssName = 'end';
      break;
    default:
      cssName = '';
      break;
  }
  return cssName === '' ? '' : `ico-state-${cssName}`;
};

export const getAnniGoalAmountPer = (
  goalAmount: number,
  totalAmount: number,
): number => {
  const per = goalAmount === 0 ? 0 : (totalAmount / goalAmount) * 100;
  return Math.round(per);
};

export const isNew = '';
